import { render } from "./NewBill.vue?vue&type=template&id=58aff33a&scoped=true"
import script from "./NewBill.vue?vue&type=script&lang=js"
export * from "./NewBill.vue?vue&type=script&lang=js"

import "./NewBill.vue?vue&type=style&index=0&id=58aff33a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58aff33a"]])

export default __exports__